<template>
    <v-container fluid>
        <v-layout align-start>
            <v-btn light outline @click="$router.push('/')">
                <v-icon>keyboard_arrow_left</v-icon>Home
            </v-btn>
        </v-layout>
         <v-card class="card--flex-toolbar mx-5 my-5 elevation-24">
            <Wizard @created="finished" />
        </v-card>
    </v-container>
</template>

<script>
import Wizard from '@/components/Wizard'

export default {
  methods: {
    finished (doc) {
      this.$router.push({name: 'dashboard-timeline', params: {id: doc.id}})
    }
  },
  components: {
      Wizard
  }
}
</script>
